import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import { CIPPrediction } from "constants/constantStrings";
import { SYSTEMS_PAGES } from "constants/pages.constant";

import { PREDICTION_TABLE_COLUMNS } from "pages/Analytics/AnalyticsPredictionTable/CIPPredictionTable.config";
import AgTable from "components/AgTable";
import PopoverText from "components/PopoverText/index.js";
import TextWithRightArrow from "components/TextWithRightArrow";

import InsightIcon from "assets/SvgIcon/InsightIcon";
import TrendingUp from "assets/SvgIcon/TrendingUp";

import InfoIconGreen from "../../../assets/Other/info-icon-green.svg";

import { CipPredictionData } from "./CipPredictionData";
import FoulingType from "./FoulingType";

import "../index.scss";

const CipPredictionCard = ({ value, customClass, setNoDataErrorMsg, isFoulingPopupOpen, setIsFoulingPopupOpen }) => {
  const [predictionData, setPredictionData] = useState(null);

  useEffect(() => {
    setPredictionData(CipPredictionData(value));
  }, []);

  const onFoulingTypeClicked = () => {
    setIsFoulingPopupOpen(true);
  };

  return (
    <div className={`insight-card ${customClass} `}>
      <div className="flex-between marginBtm10 ">
        <div className="fullWidth">
          <div className="d-flex marginBtm10">
            <h1>{CIPPrediction.cip}</h1>
            <PopoverText
              descriptor={<img src={InfoIconGreen} alt="icon" />}
              descriptionText={CIPPrediction.predictionInfo}
              customClass="popover-width"
            />
          </div>
          <h4>{CIPPrediction[value.Smoothening_Technique_data]}</h4>
          <div className="table-Container">
            {predictionData && (
              <AgTable
                rowData={predictionData}
                columnDefs={PREDICTION_TABLE_COLUMNS("prediction")}
                rowHeight="auto"
                customTableClass="ag-theme-readOnly-react table-header"
              />
            )}
          </div>
          <h4>{CIPPrediction.predictionWindow}</h4>

          <div className=" marginTop10 fouling-text width_fit-content">
            <InsightIcon />
            <TextWithRightArrow text={CIPPrediction.foulingType} fontStyle={"clickable-green-text"} onClick={onFoulingTypeClicked} />
          </div>
          <div className="marginTop5 inspect-text width_fit-content ">
            <NavLink to={`../${SYSTEMS_PAGES.ANALYTICS}`}>
              <TrendingUp />
              <TextWithRightArrow text={CIPPrediction.inspectfurther} fontStyle={"clickable-green-text"} />
            </NavLink>
          </div>
          {isFoulingPopupOpen && (
            <FoulingType open={isFoulingPopupOpen} setNoDataErrorMsg={setNoDataErrorMsg} setIsFoulingPopupOpen={setIsFoulingPopupOpen} />
          )}
        </div>
      </div>
    </div>
  );
};

export default CipPredictionCard;
